/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import { Fragment } from 'react';

// Component imports
import { t } from 'i18next';
import { Divider, Form, Input, Typography } from 'antd';

// Constant declarations
const { Text } = Typography;

const WitProviderForm = () => {
  <Fragment>
    <Divider orientation="left" className="mb-8">
      <Text type="secondary" className="fs-base">{t('Provider Settings')}</Text>
    </Divider>

    <Form.Item
      label={t('App ID')}
      labelAlign="left"
      labelCol={{ xs: 24, sm: 24, md: 6, xl: 5 }}
      wrapperCol={{ xs: 24, sm: 24, md: 12, xl: 10 }}
      name="appId"
      rules={[{
        required: true,
        type: 'string',
        whitespace: true
      }]}
    >
      <Input placeholder={t('Enter the application ID')} />
    </Form.Item>

    <Form.Item
      label={t('App Key')}
      labelAlign="left"
      labelCol={{ xs: 24, sm: 24, md: 6, xl: 5 }}
      wrapperCol={{ xs: 24, sm: 24, md: 12, xl: 10 }}
      name="key"
      rules={[{
        required: true,
        type: 'string',
        whitespace: true
      }]}
    >
      <Input placeholder={t('Enter the application key')} />
    </Form.Item>
  </Fragment>;
};

export default WitProviderForm;
